import { Descriptions, Space, Table, Tag, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import type { GlobalAssignmentBlockDiagnostics } from "../../../shared/scriptRoleGlobalAssignmentDiagnostics";

const { Paragraph, Text } = Typography;

export function GlobalAssignmentBlockDetail(props: {
  diagnostics: GlobalAssignmentBlockDiagnostics;
  compact?: boolean;
}) {
  const { diagnostics, compact = false } = props;

  const columns: ColumnsType<(typeof diagnostics.rejections)[number]> = [
    {
      title: "排名",
      dataIndex: "rank",
      width: 56,
    },
    {
      title: "编号",
      dataIndex: "number",
      width: 72,
    },
    {
      title: "昵称",
      dataIndex: "nickname",
      width: 96,
      render: (value: string) => value || "—",
    },
    {
      title: "得分",
      dataIndex: "score",
      width: 64,
      render: (value?: number) => (Number.isFinite(value) ? value : "—"),
    },
    {
      title: "被拒原因",
      dataIndex: "reasonLabels",
      render: (labels: string[]) => (
        <Space size={[4, 4]} wrap>
          {labels.map((label) => (
            <Tag key={label} color="error">
              {label}
            </Tag>
          ))}
        </Space>
      ),
    },
  ];

  if (compact) {
    return (
      <Space direction="vertical" size={8} style={{ width: "100%" }}>
        <Paragraph style={{ marginBottom: 0, whiteSpace: "pre-wrap" }}>
          {diagnostics.summary}
        </Paragraph>
        {diagnostics.rejections.length > 0 ? (
          <Text type="secondary">
            共 {diagnostics.rejections.length} 个候选被拒，展开查看明细。
          </Text>
        ) : null}
      </Space>
    );
  }

  return (
    <Space direction="vertical" size={12} style={{ width: "100%" }}>
      <Paragraph style={{ marginBottom: 0, whiteSpace: "pre-wrap" }}>
        {diagnostics.summary}
      </Paragraph>
      <Descriptions size="small" bordered column={2}>
        <Descriptions.Item label="阻塞角色">
          气氛员{diagnostics.blockedTempRoleId}
        </Descriptions.Item>
        <Descriptions.Item label="内容类型">
          {diagnostics.contentBeatLabel}
        </Descriptions.Item>
        <Descriptions.Item label="候选数">
          Top{diagnostics.candidateCount}
        </Descriptions.Item>
        {diagnostics.candidatePool ? (
          <Descriptions.Item label="候选池">
            {diagnostics.candidatePool.searchedCandidateCount} / {diagnostics.candidatePool.availableMemberCount}
            {diagnostics.candidatePool.exhausted ? "（已耗尽）" : "（待扩容）"}
          </Descriptions.Item>
        ) : null}
        <Descriptions.Item label="每人出场上限">
          {diagnostics.maxAppearancesPerMember} 次
        </Descriptions.Item>
        <Descriptions.Item label="此前已分配">
          {diagnostics.assignedRoleCountBeforeBlock} 个角色
        </Descriptions.Item>
        <Descriptions.Item label="晒单占用">
          {diagnostics.priorOrderShowCountBeforeBlock} 个账号
        </Descriptions.Item>
      </Descriptions>
      {diagnostics.reasonCounts.length > 0 ? (
        <Space size={[8, 8]} wrap>
          {diagnostics.reasonCounts.map((item) => (
            <Tag key={item.code}>
              {item.label} × {item.count}
            </Tag>
          ))}
        </Space>
      ) : null}
      {diagnostics.rejections.length > 0 ? (
        <Table
          size="small"
          rowKey={(row) => `${row.rank}-${row.number}`}
          pagination={false}
          scroll={{ y: 240 }}
          dataSource={diagnostics.rejections}
          columns={columns}
        />
      ) : null}
    </Space>
  );
}
